import { render, staticRenderFns } from "./EChartDesempenho.vue?vue&type=template&id=98883862"
import script from "./EChartDesempenho.vue?vue&type=script&lang=js"
export * from "./EChartDesempenho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports